import './vendor/bootstrap';
import 'slick-carousel';
import './app/forms';
import './app/homepage';



// WEBPACK FOOTER //
// ./src/js/bundle.js